import { useUserStore } from 'hooks/stores/useUserStore';
import { observer } from 'mobx-react-lite';
import Link from 'next/link';
import AboutUsModule from '../about-us/AboutUsModule';
import AboutUsSiteContainer from '../about-us/AboutUsSiteContainer';
import styles from './DashboardLinks.module.css';

import AboutUs from '../svg/AboutUs40x36.svg';
import ContactUs from '../svg/ContactUs45x36.svg';
import FAQ from '../svg/FAQ30x37.svg';
import MyAccount from '../svg/MyAccount35x37.svg';

const DashboardLinks = observer(({ loading }: { loading?: boolean }) => {
  const { currentUser, subscriptions } = useUserStore();

  const isActiveSubscriber =
    currentUser?.id &&
    subscriptions.find(
      (s) =>
        s.subscription.status === 'ACTIVE' ||
        s.subscription.status === 'SNOOZED' ||
        s.subscription.status === 'FAILING',
    );

  const links = [
    {
      href: '/account',
      text: 'Your account',
      Icon: MyAccount,
    },
    {
      href: isActiveSubscriber
        ? 'https://daymade.zendesk.com/hc/en-gb'
        : '/faq',
      text: 'FAQ',
      Icon: FAQ,
    },
    {
      href: '/about-us',
      text: 'About us',
      Icon: AboutUs,
    },
    {
      href: '/contact-us',
      text: 'Contact us',
      Icon: ContactUs,
    },
  ];

  if (loading) {
    return null;
  }

  return (
    <AboutUsModule
      background={'tealGradient'}
      withNoPadding
      extendBackgroundAbove
    >
      <AboutUsSiteContainer>
        <div className={styles.linksWrapper}>
          {links.map((link, i) => (
            <Link key={i} href={link.href} className={styles.dashboardLink}>

              <div className={styles.dashboardLinkIcon}>
                <link.Icon />
              </div>
              <strong>{link.text}</strong>

            </Link>
          ))}
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
});

export default DashboardLinks;
